module.exports = __webpack_public_path__ + "images/accents/accent-interaction-properties-a48684f1ad4d5f055f8ba28770ec3538.webp";